import NavigationBar from "../../../navigation_components/NavigationBar";
import SystemAdministratorSideBar from "../../../sidebar_components/SystemAdministratorSideBar";
import "../../../../styles/workspace_styles/SystemAdministratorStyles/Accounts/Account.css";
import { useState } from "react";
import Profile from "./Profile";
import Security from "./Security";
import BottomRightMessageBox from "../../UniversalComponents/BottomRightMessageBox";

const Account = () =>{
    const [selectedAccountTab,setSelectedAccountTab] = useState('profile');
    return(
        <div className="system-administrator-account-page">
            <NavigationBar/>
            <div className="system-administrator-account-page-layout">
                <div>
                    <SystemAdministratorSideBar/>
                </div>
                <div className="system-administrator-account-parent-container">
                    <div className="system-administrator-account-container">
                        <div className="system-administrator-account-navigation-bar">
                            <button className={selectedAccountTab === 'profile'? 'active':''}
                                onClick={() =>setSelectedAccountTab('profile')}>
                                <img src={`${process.env.PUBLIC_URL}/images/user-icon-blue.png`}/>
                                <p>Profile</p>
                            </button>
                            <button className={selectedAccountTab === 'security'? 'active':''}
                                onClick={() => setSelectedAccountTab('security')}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/security-config-icon.png`}
                                />
                                <p>Security</p>
                            </button>
                        </div>
                        <div className="system-administrator-account-body">
                            {selectedAccountTab === 'profile'? <Profile/>:<Security/>}
                        </div>
                    </div>
                </div>
            </div>
            <BottomRightMessageBox/>
        </div>
    );
};
export default Account;